document.addEventListener('DOMContentLoaded', () => {
  const navToggle = document.querySelector('[data-nav-toggle]');
  const siteNav = document.querySelector('[data-site-nav]');

  if (navToggle && siteNav) {
    const closeNav = () => {
      siteNav.classList.remove('is-open');
      navToggle.setAttribute('aria-expanded', 'false');
    };

    const openNav = () => {
      siteNav.classList.add('is-open');
      navToggle.setAttribute('aria-expanded', 'true');
    };

    navToggle.addEventListener('click', () => {
      if (siteNav.classList.contains('is-open')) {
        closeNav();
        return;
      }

      openNav();
    });

    siteNav.addEventListener('click', (event) => {
      const link = event.target.closest('a');

      if (link) {
        closeNav();
      }
    });

    document.addEventListener('click', (event) => {
      if (!siteNav.classList.contains('is-open')) {
        return;
      }

      if (siteNav.contains(event.target) || navToggle.contains(event.target)) {
        return;
      }

      closeNav();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 980) {
        closeNav();
      }
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    },
    {
      threshold: 0.15,
    }
  );

  document.querySelectorAll('.reveal').forEach((node) => observer.observe(node));

  document.querySelectorAll('[data-hero-video]').forEach((video) => {
    const container = video.closest('.hero-image');
    const playButton = container?.querySelector('[data-hero-play]');
    const loopEnd = Number(video.dataset.loopEnd || 0);
    const hasCustomLoop = Number.isFinite(loopEnd) && loopEnd > 0;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.load();

    const markPlaying = () => {
      container?.classList.add('is-playing');
    };

    const tryPlay = () => {
      const playPromise = video.play();

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(markPlaying).catch(() => {});
      }
    };

    const syncLoop = () => {
      if (!hasCustomLoop || video.seeking) {
        return;
      }

      if (video.currentTime >= loopEnd) {
        video.currentTime = 0;
        tryPlay();
      }
    };

    video.addEventListener('canplay', tryPlay);
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('playing', markPlaying);
    video.addEventListener('timeupdate', syncLoop);
    video.addEventListener('ended', syncLoop);
    playButton?.addEventListener('click', tryPlay);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        tryPlay();
      }
    });

    tryPlay();
    setTimeout(tryPlay, 200);
    setTimeout(tryPlay, 900);
  });

  const bookingRoot = document.querySelector('[data-crowned-booking]');

  if (bookingRoot) {
    const serviceSelect = bookingRoot.querySelector('[data-booking-service]');
    const lengthSelect = bookingRoot.querySelector('[data-booking-length]');
    const addOnSelect = bookingRoot.querySelector('[data-booking-addon]');
    const dateInput = bookingRoot.querySelector('[data-booking-date]');
    const timeSelect = bookingRoot.querySelector('[data-booking-time]');
    const nameInput = bookingRoot.querySelector('[data-booking-name]');
    const contactInput = bookingRoot.querySelector('[data-booking-contact]');
    const depositLink = bookingRoot.querySelector('[data-deposit-link]');
    const serviceCards = document.querySelectorAll('[data-service-card]');
    const monthLabel = bookingRoot.querySelector('[data-calendar-month]');
    const daysRoot = bookingRoot.querySelector('[data-calendar-days]');
    const prevMonthButton = bookingRoot.querySelector('[data-calendar-prev]');
    const nextMonthButton = bookingRoot.querySelector('[data-calendar-next]');

    const priceOutput = bookingRoot.querySelector('[data-summary-price]');
    const depositOutput = bookingRoot.querySelector('[data-summary-deposit]');
    const serviceOutput = bookingRoot.querySelector('[data-summary-service]');
    const dateOutput = bookingRoot.querySelector('[data-summary-date]');
    const timeOutput = bookingRoot.querySelector('[data-summary-time]');
    const lengthOutput = bookingRoot.querySelector('[data-summary-length]');
    const addOnOutput = bookingRoot.querySelector('[data-summary-addon]');
    const durationOutput = bookingRoot.querySelector('[data-summary-duration]');
    const summaryText = bookingRoot.querySelector('[data-summary-text]');
    const summaryStatus = bookingRoot.querySelector('[data-booking-status]');
    const contactLabel = bookingRoot.querySelector('label[for="crowned-contact"]');
    const catalogUrl = bookingRoot.dataset.catalogUrl || '/apps/crownd/catalog';
    const availabilityUrl =
      bookingRoot.dataset.availabilityUrl || '/apps/crownd/availability?days=31';
    const checkoutUrl = bookingRoot.dataset.checkoutUrl || '/apps/crownd/checkout';
    const fallbackCheckoutUrl =
      bookingRoot.dataset.fallbackCheckoutUrl ||
      depositLink.getAttribute('href') ||
      '';
    const hasFallbackCheckout =
      Boolean(fallbackCheckoutUrl) && !fallbackCheckoutUrl.startsWith('#');

    const getSelectedServiceProductUrl = () => {
      const selectedOption = serviceSelect.selectedOptions[0];
      const productHandle =
        selectedOption?.dataset.productHandle ||
        getSelectedService()?.productHandle ||
        '';

      if (productHandle) {
        return `/products/${productHandle}`;
      }

      return '';
    };

    if (
      serviceSelect &&
      lengthSelect &&
      addOnSelect &&
      dateInput &&
      timeSelect &&
      nameInput &&
      contactInput &&
      depositLink &&
      monthLabel &&
      daysRoot &&
      prevMonthButton &&
      nextMonthButton &&
      priceOutput &&
      depositOutput &&
      serviceOutput &&
      dateOutput &&
      timeOutput &&
      lengthOutput &&
      addOnOutput &&
      durationOutput &&
      summaryText &&
      summaryStatus
    ) {
      const formatDateValue = (date) => {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const today = new Date();
      const todayValue = formatDateValue(today);
      let visibleMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      let checkoutReady = false;
      let submitting = false;
      let liveServices = [];
      let bookingPolicy = '';
      let availableSlotsByDate = new Map();

      dateInput.min = todayValue;

      const formatFriendlyDate = (value) => {
        if (!value) {
          return 'Choose a date';
        }

        const date = new Date(`${value}T00:00:00`);

        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        });
      };

      const formatDuration = (minutes) => {
        const durationMinutes = Number(minutes || 0);

        if (!durationMinutes) {
          return '';
        }

        const hours = Math.floor(durationMinutes / 60);
        const remainder = durationMinutes % 60;

        if (hours && remainder) {
          return `${hours} hr ${remainder} min`;
        }

        if (hours) {
          return `${hours} hr`;
        }

        return `${remainder} min`;
      };

      const formatPriceRange = (service) => {
        if (!service) {
          return '$0';
        }

        return service.priceFrom === service.priceTo
          ? service.priceFrom
          : `${service.priceFrom} - ${service.priceTo}`;
      };

      const setStatus = (message, tone = 'neutral') => {
        summaryStatus.textContent = message || '';
        summaryStatus.classList.remove('is-error', 'is-success');

        if (tone === 'error') {
          summaryStatus.classList.add('is-error');
        }

        if (tone === 'success') {
          summaryStatus.classList.add('is-success');
        }
      };

      const setCheckoutButton = ({ disabled, loading, text }) => {
        depositLink.textContent = text;
        depositLink.classList.toggle('is-disabled', disabled);
        depositLink.classList.toggle('is-loading', loading);
        depositLink.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      };

      const getSelectedService = () =>
        liveServices.find((service) => service.slug === serviceSelect.value) || null;

      const getSlotsForDate = (value) => availableSlotsByDate.get(value) || [];

      const getSelectedSlot = () => {
        const slots = getSlotsForDate(dateInput.value);
        const selectedValue = timeSelect.value;

        return (
          slots.find((slot) => slot.startLocal === selectedValue) || slots[0] || null
        );
      };

      const buildBookingNotes = () => {
        const notes = [];

        if (lengthSelect.selectedOptions[0]?.text) {
          notes.push(`Length / density: ${lengthSelect.selectedOptions[0].text}`);
        }

        if (addOnSelect.value !== 'none' && addOnSelect.selectedOptions[0]?.text) {
          notes.push(`Add-on interest: ${addOnSelect.selectedOptions[0].text}`);
        }

        return notes.join(' | ');
      };

      const setActiveCard = () => {
        serviceCards.forEach((card) => {
          card.classList.toggle('is-active', card.getAttribute('data-service-card') === serviceSelect.value);
        });
      };

      const populateTimeOptions = () => {
        const slots = getSlotsForDate(dateInput.value);
        const previouslySelected = timeSelect.value;

        timeSelect.innerHTML = '';

        if (!slots.length) {
          const option = document.createElement('option');
          option.value = '';
          option.textContent = 'No times available';
          timeSelect.appendChild(option);
          timeSelect.disabled = true;
          return;
        }

        timeSelect.disabled = false;

        slots.forEach((slot, index) => {
          const option = document.createElement('option');
          option.value = slot.startLocal;
          option.textContent = slot.label;

          if (slot.startLocal === previouslySelected || (!previouslySelected && index === 0)) {
            option.selected = true;
          }

          timeSelect.appendChild(option);
        });
      };

      const renderCalendar = () => {
        daysRoot.innerHTML = '';
        monthLabel.textContent = visibleMonth.toLocaleDateString('en-US', {
          month: 'long',
          year: 'numeric',
        });

        const year = visibleMonth.getFullYear();
        const month = visibleMonth.getMonth();
        const firstDay = new Date(year, month, 1);
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        for (let i = 0; i < firstDay.getDay(); i += 1) {
          const blank = document.createElement('div');
          blank.className = 'crowned-calendar__blank';
          daysRoot.appendChild(blank);
        }

        for (let day = 1; day <= daysInMonth; day += 1) {
          const button = document.createElement('button');
          const dateValue = formatDateValue(new Date(year, month, day));
          const slots = getSlotsForDate(dateValue);

          button.type = 'button';
          button.className = 'crowned-calendar__day';
          button.textContent = `${day}`;

          if (dateValue < todayValue || !slots.length) {
            button.classList.add('is-disabled');
            button.disabled = true;
          } else {
            button.addEventListener('click', () => {
              dateInput.value = dateValue;
              visibleMonth = new Date(year, month, 1);
              populateTimeOptions();
              updateBookingSummary();
            });
          }

          if (dateInput.value === dateValue) {
            button.classList.add('is-selected');
          }

          daysRoot.appendChild(button);
        }
      };

      const populateServiceOptions = () => {
        const previousValue = serviceSelect.value;

        serviceSelect.innerHTML = '';

        liveServices.forEach((service, index) => {
          const option = document.createElement('option');
          option.value = service.slug;
          option.textContent = service.title;
          option.dataset.productHandle =
            service.productHandle || `crownd-booking-${service.slug}`;

          if (service.slug === previousValue || (!previousValue && index === 0)) {
            option.selected = true;
          }

          serviceSelect.appendChild(option);
        });
      };

      const updateBookingSummary = () => {
        const service = getSelectedService();
        const slot = getSelectedSlot();
        const lengthLabel = lengthSelect.selectedOptions[0]?.text || 'Not selected';
        const addOnLabel = addOnSelect.selectedOptions[0]?.text || 'None';
        const notes = buildBookingNotes();

        priceOutput.textContent = formatPriceRange(service);
        depositOutput.textContent = service?.deposit || '$0';
        serviceOutput.textContent = service?.title || 'Choose a service';
        dateOutput.textContent = slot ? formatFriendlyDate(dateInput.value) : 'Choose a date';
        timeOutput.textContent =
          timeSelect.selectedOptions[0]?.text || 'Select a date first';
        lengthOutput.textContent = lengthLabel;
        addOnOutput.textContent = addOnLabel;
        durationOutput.textContent = formatDuration(service?.durationMinutes);
        summaryText.textContent =
          service?.description ||
          'Select a service, choose an available date and time, and continue to checkout.';

        if (bookingPolicy) {
          summaryText.textContent = `${summaryText.textContent} ${bookingPolicy}`;
        }

        if (notes) {
          summaryText.textContent = `${summaryText.textContent} ${notes}`;
        }

        const selectedDate = dateInput.value ? new Date(`${dateInput.value}T00:00:00`) : today;
        visibleMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);

        setActiveCard();
        renderCalendar();

        if (submitting) {
          setCheckoutButton({
            disabled: true,
            loading: true,
            text: 'Preparing Checkout...',
          });
          return;
        }

        if (!checkoutReady) {
          const fallbackTarget = hasFallbackCheckout
            ? fallbackCheckoutUrl
            : getSelectedServiceProductUrl();

          if (fallbackTarget) {
            depositLink.href = fallbackTarget;
            setCheckoutButton({
              disabled: false,
              loading: false,
              text: hasFallbackCheckout ? 'Continue to Booking' : 'Book Now',
            });
          } else {
            setCheckoutButton({
              disabled: true,
              loading: false,
              text: 'Booking Unavailable',
            });
          }
          return;
        }

        if (!service) {
          setCheckoutButton({
            disabled: true,
            loading: false,
            text: 'Choose Live Service',
          });
          return;
        }

        if (!slot) {
          setCheckoutButton({
            disabled: true,
            loading: false,
            text: 'No Times Available',
          });
          return;
        }

        const canCheckout =
          Boolean(nameInput.value.trim()) &&
          Boolean(contactInput.value.trim());

        setCheckoutButton({
          disabled: !canCheckout,
          loading: false,
          text: canCheckout ? 'Book Appointment' : 'Complete Booking Details',
        });
      };

      const syncAvailability = () => {
        const availableDates = Array.from(availableSlotsByDate.keys()).sort();

        if (!availableDates.length) {
          dateInput.value = '';
          populateTimeOptions();
          return false;
        }

        if (!availableSlotsByDate.has(dateInput.value)) {
          dateInput.value = availableDates[0];
        }

        const selectedDate = new Date(`${dateInput.value}T00:00:00`);
        visibleMonth = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          1
        );
        populateTimeOptions();

        return true;
      };

      const loadLiveBookingData = async () => {
        setStatus('Loading live booking schedule...');
        setCheckoutButton({
          disabled: true,
          loading: true,
          text: 'Loading Booking...',
        });

        try {
          const [catalogResponse, availabilityResponse] = await Promise.all([
            fetch(catalogUrl, {
              headers: { Accept: 'application/json' },
            }),
            fetch(availabilityUrl, {
              headers: { Accept: 'application/json' },
            }),
          ]);

          if (!catalogResponse.ok) {
            throw new Error('Unable to load live Crownd services right now.');
          }

          if (!availabilityResponse.ok) {
            throw new Error('Unable to load live Crownd availability right now.');
          }

          const catalogData = await catalogResponse.json();
          const availabilityData = await availabilityResponse.json();

          liveServices = Array.isArray(catalogData?.services)
            ? catalogData.services.filter((service) => service.depositVariantReady)
            : [];
          bookingPolicy = String(catalogData?.settings?.bookingPolicy || '').trim();

          if (contactLabel && catalogData?.settings?.bookingContactLabel) {
            contactLabel.textContent = catalogData.settings.bookingContactLabel;
          }

          availableSlotsByDate = new Map(
            Array.isArray(availabilityData?.days)
              ? availabilityData.days.map((day) => [
                  day.date,
                  Array.isArray(day.slots) ? day.slots : [],
                ])
              : []
          );

          if (!liveServices.length) {
            throw new Error(
              'No deposit-ready services are live yet. Finish the Services setup in the Crownd app first.'
            );
          }

          checkoutReady = true;
          populateServiceOptions();

          if (!syncAvailability()) {
            setStatus('No booking slots are available right now.', 'error');
            updateBookingSummary();
            return;
          }

          updateBookingSummary();
          setStatus(
            'Live booking is connected. Choose a service and available time.',
            'success'
          );
        } catch (error) {
          checkoutReady = false;
          setStatus(
            hasFallbackCheckout
              ? `${
                  error instanceof Error
                    ? error.message
                    : 'Live booking is unavailable right now.'
                } Use the fallback booking link below.`
              : error instanceof Error
                ? error.message
                : 'Live booking is unavailable right now.',
            'error'
          );
          updateBookingSummary();
        }
      };

      prevMonthButton.addEventListener('click', () => {
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() - 1, 1);
        renderCalendar();
      });

      nextMonthButton.addEventListener('click', () => {
        visibleMonth = new Date(visibleMonth.getFullYear(), visibleMonth.getMonth() + 1, 1);
        renderCalendar();
      });

      serviceCards.forEach((card) => {
        card.addEventListener('click', () => {
          const serviceValue = card.getAttribute('data-service-card');

          if (
            serviceValue &&
            Array.from(serviceSelect.options).some((option) => option.value === serviceValue)
          ) {
            serviceSelect.value = serviceValue;
            updateBookingSummary();
          }
        });
      });

      serviceSelect.addEventListener('change', updateBookingSummary);
      lengthSelect.addEventListener('change', updateBookingSummary);
      addOnSelect.addEventListener('change', updateBookingSummary);
      timeSelect.addEventListener('change', updateBookingSummary);
      nameInput.addEventListener('input', updateBookingSummary);
      contactInput.addEventListener('input', updateBookingSummary);
      dateInput.addEventListener('change', () => {
        populateTimeOptions();
        updateBookingSummary();
      });

      depositLink.addEventListener('click', async (event) => {
        if (depositLink.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }

        if (!checkoutReady) {
          setStatus('Opening the booking checkout link.');
          return;
        }

        event.preventDefault();

        const service = getSelectedService();
        const slot = getSelectedSlot();

        if (!service || !slot || !nameInput.value.trim() || !contactInput.value.trim()) {
          setStatus(
            'Choose a live service, available time, name, and contact detail before checkout.',
            'error'
          );
          updateBookingSummary();
          return;
        }

        submitting = true;
        setStatus('Preparing your checkout...');
        updateBookingSummary();

        try {
          const checkoutResponse = await fetch(checkoutUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              serviceSlug: service.slug,
              appointmentStart: slot.startLocal,
              customerName: nameInput.value.trim(),
              customerContact: contactInput.value.trim(),
              notes: buildBookingNotes(),
            }),
          });

          const checkoutData = await checkoutResponse.json().catch(() => null);

          if (!checkoutResponse.ok || !checkoutData?.cart?.body) {
            throw new Error(
              checkoutData?.error ||
                'Unable to create the Crownd checkout right now.'
            );
          }

          const cartResponse = await fetch(checkoutData.cart.endpoint || '/cart/add.js', {
            method: checkoutData.cart.method || 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(checkoutData.cart.body),
          });

          if (!cartResponse.ok) {
            throw new Error('Unable to add the booking deposit to the Shopify cart.');
          }

          setStatus('Redirecting to checkout...', 'success');
          window.location.assign(checkoutData.cart.redirectTo || '/checkout');
        } catch (error) {
          submitting = false;
          setStatus(
            error instanceof Error
              ? error.message
              : 'Unable to create the booking checkout right now.',
            'error'
          );
          updateBookingSummary();
        }
      });

      updateBookingSummary();
      loadLiveBookingData();
    }
  }
});
